const StartButton = (props) => {
    return (
        <button className="StartButton" onClick={props.onClick}> Start Game!</button>
    );
}


export default StartButton;
